import { useI18n } from 'vue-i18n';
import type { RadarDepthCounts } from '~/help/radarDepth';

// Tooltip radar partagé profil / comparaison : « 4 expériences · 3 validées ».
export function useRadarTooltip() {
  const { t } = useI18n();
  return (counts: RadarDepthCounts): string => {
    if (counts.count <= 0) return t('profile_skills.tooltip_no_experience');
    const exp = t('profile_skills.tooltip_experiences', { count: counts.count }, counts.count);
    if (counts.validated_count <= 0) return exp;
    return `${exp} · ${t('profile_skills.tooltip_validated', { count: counts.validated_count }, counts.validated_count)}`;
  };
}
